import {
  Box,
  Typography,
  Grid,
  Button,
  FormHelperText,
  Chip,
  Divider,
  Paper,
  Fade,
  RadioGroup,
  Radio,
  InputAdornment,
} from "@mui/material";
import { SectionHeader } from "../index";
import MDBox from "components/MDBox";
import MDDatePicker from "components/MDDatepicker";
import Iconify from "components/Iconify";
import MDSelectBox from "components/MDSelectBox";
import { useContext, useEffect, useState } from "react";
import { occasionOption } from "Apis/occasion";
import MDInput from "components/MDInput";
import { MemberContext } from "context/MemberContext";
import dayjs from "dayjs";

const SLOTS = [
  {
    id: 1,
    label: "Morning Slot",
    time: "8:00 AM - Next Day 7:00 AM",
    desc: "23 hrs from 8 AM",
  },
  {
    id: 2,
    label: "Evening Slot",
    time: "4:00 PM - Next Day 3:00 PM",
    desc: "23 hrs from 4 PM",
  },
];

export const StepDates = ({
  values,
  setFieldValue,
  errors,
  touched,
  canStep0,
  handleBlur,
  handleChange,
  setActiveStep,
  isMember,
  handelCheckAmenityAvailable,
}) => {
  const [occasionListData, setOccasionListData] = useState([]);
  const { parentMemberList, parentDataListing } = useContext(MemberContext);
  const getOccasionListApi = async () => {
    const data = {
      is_admin: true,
    };
    let response = await occasionOption(data);

    if (response?.status === 200) {
      const sortedData = response.data.data.rows
        ?.map((item) => ({
          value: parseInt(item?.id),
          label: item?.name,
        }))
        ?.sort((a, b) => a?.label?.localeCompare(b.label));

      setOccasionListData(sortedData);
    }
  };
  useEffect(() => {
    getOccasionListApi();
    parentDataListing();
  }, []);
  const handleMemberChange = (value) => {
    if (value) {
      setFieldValue("member_id", value?.value);
      setFieldValue("memberNumber", value?.label);
    } else {
      setFieldValue("member_id", "");
      setFieldValue("memberNumber", "");
    }
  };
  const handleOccasionChange = (value) => {
    if (value) {
      setFieldValue("occasion_id", value?.value);
      setFieldValue("occasion", value?.label);
    }
  };
  return (
    <Fade in timeout={350}>
      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          p: { xs: 2.5, md: 4 },
          border: `1px solid #dee2e6`,
          backgroundColor: "#ffffff",
        }}
      >
        <SectionHeader title="Booking Details" />

        <Grid container spacing={2.5} mb={4}>
          <Grid item xs={12}>
            <Box
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 3,
                p: 2.5,
                mb: 2.5,
                backgroundColor: "#fff",
              }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#7b809a",
                  textTransform: "uppercase",
                  mb: 1.5,
                  letterSpacing: "0.08em",
                }}
              >
                Booking For
              </Typography>

              <RadioGroup
                row
                name="memberType"
                value={values?.memberType}
                onChange={(e) => setFieldValue("memberType", e?.target?.value)}
                sx={{ gap: 2 }}
              >
                {[
                  { label: "Member", value: "member" },
                  { label: "Non-Member", value: "nonMember" },
                ].map((option) => {
                  const isSelected = values?.memberType === option?.value;

                  return (
                    <Box
                      key={option?.value}
                      onClick={() => setFieldValue("memberType", option?.value)}
                      sx={{
                        flex: 1,
                        border: `1.5px solid ${isSelected ? "#A68181" : "#e0e0e0"}`,
                        borderRadius: 2,
                        px: 2,
                        py: 1.5,
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        backgroundColor: isSelected ? "#f9f4f4" : "#fff",

                        "&:hover": {
                          borderColor: "#A68181",
                          backgroundColor: "#faf6f6",
                        },
                      }}
                    >
                      <Radio
                        checked={isSelected}
                        value={option?.value}
                        sx={{
                          p: 0.5,
                          mr: 1,
                          color: "#A68181",
                          "&.Mui-checked": { color: "#A68181" },
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: 14,
                          fontWeight: 500,
                          color: "#344767",
                        }}
                      >
                        {option?.label}
                      </Typography>
                    </Box>
                  );
                })}
              </RadioGroup>
              {isMember && (
                <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important" }}>
                  <MDSelectBox
                    name="memberNumber"
                    defaultValue={values?.memberNumber}
                    options={parentMemberList}
                    handleChange={(value) => handleMemberChange(value)}
                    label="Head Member"
                    width="100%"
                    multiple={false}
                    onBlur={handleBlur}
                    required
                  />
                  {touched?.memberNumber && errors?.memberNumber && (
                    <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                      {errors?.memberNumber}
                    </MDBox>
                  )}
                </Grid>
              )}
              {!isMember && (
                <Grid container spacing={2.5} sx={{ paddingTop: "30px !important" }}>
                  <Grid item xs={12} md={6}>
                    <MDInput
                      type="text"
                      name="name"
                      label="Full Name"
                      required
                      variant="standard"
                      value={values?.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                    />
                    {touched?.name && errors?.name && (
                      <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                        {errors?.name}
                      </MDBox>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput
                      type="text"
                      name="mobile"
                      label="Mobile Number"
                      required
                      variant="standard"
                      value={values?.mobile}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment
                            // sx={{ fontSize: "12px !important" }}
                            fontSize={12}
                            position="start"
                          >
                            <span>+91</span>
                          </InputAdornment>
                        ),
                      }}
                    />
                    {touched?.mobile && errors?.mobile && (
                      <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                        {errors?.mobile}
                      </MDBox>
                    )}
                  </Grid>
                </Grid>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} sx={{ paddingTop: "30px !important" }}>
            <MDDatePicker
              width="100% !important"
              name="start_date"
              value={values?.start_date}
              onChange={(v) => {
                const formattedDate = v ? v.format("YYYY-MM-DD") : "";
                setFieldValue("start_date", formattedDate);
                if (!values?.end_date) {
                  setFieldValue("end_date", formattedDate);
                }
                if (values?.end_date < formattedDate) {
                  setFieldValue("end_date", formattedDate);
                }
              }}
              label="Start Date"
              disablePast={false}
              required
            />
            {touched?.start_date && errors?.start_date && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {errors?.start_date}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} sm={6} sx={{ paddingTop: "30px !important" }}>
            <MDDatePicker
              width="100% !important"
              name="end_date"
              value={values?.end_date}
              onChange={(v) => {
                const formattedDate = v ? v.format("YYYY-MM-DD") : "";
                setFieldValue("end_date", formattedDate);
              }}
              label="End Date"
              minDate={dayjs(values?.start_date)}
              disablePast={false}
              required
            />
            {touched?.end_date && errors?.end_date && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {errors?.end_date}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={6}>
            <MDSelectBox
              name="occasion"
              defaultValue={values?.occasion}
              options={occasionListData}
              handleChange={(value) => handleOccasionChange(value)}
              label="Occasion"
              width="100%"
              multiple={false}
              onBlur={handleBlur}
              required
            />
            {touched?.occasion && errors?.occasion && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {errors?.occasion}
              </MDBox>
            )}
          </Grid>
        </Grid>

        <Divider sx={{ mb: 3.5, borderColor: "#f0f2f5" }} />

        <SectionHeader title="Booking Slot" />

        <Grid container spacing={2}>
          {SLOTS?.map((slot) => {
            const active = values?.slot === slot?.id;
            return (
              <Grid item xs={12} sm={6} key={slot?.id}>
                <Box
                  onClick={() => setFieldValue("slot", slot?.id)}
                  sx={{
                    border: `${active ? "2px" : "1.5px"} solid ${active ? "#A68181" : "#d2d6da"}`,
                    borderRadius: 2.5,
                    p: 3,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    cursor: "pointer",
                    backgroundColor: active ? "#FFF2F2" : "#ffffff",
                    transition: "all 0.22s",
                    position: "relative",
                    overflow: "hidden",
                    "&:hover": {
                      borderColor: "#A68181",
                      backgroundColor: "#FFF2F2",
                      transform: "translateY(-2px)",
                      boxShadow: `0 6px 20px #A6818122`,
                    },
                  }}
                >
                  {active && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        height: 3,
                        backgroundColor: "#A68181",
                      }}
                    />
                  )}
                  <Box
                    sx={{
                      width: 20,
                      height: 20,
                      borderRadius: "50%",
                      border: `2px solid ${active ? "#A68181" : "#c0c0c0"}`,
                      backgroundColor: active ? "#FFF5F5" : "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      transition: "border-color 0.2s",
                    }}
                  >
                    {active && (
                      <Box
                        sx={{
                          width: 12,
                          height: 12,
                          borderRadius: "50%",
                          backgroundColor: "#A68181",
                        }}
                      />
                    )}
                  </Box>
                  <Box>
                    {slot?.icon && (
                      <Typography fontSize={32} mb={1.5}>
                        {slot?.icon}
                      </Typography>
                    )}
                    <Typography fontWeight={700} color="#344767" fontSize={16} mb={0.5}>
                      {slot?.label}
                    </Typography>
                    <Typography
                      // variant="body2"
                      fontSize={14}
                      sx={{
                        color: "#7b809a",
                        mb: 1.5,
                      }}
                    >
                      {slot?.time}
                    </Typography>
                    <Chip
                      label={slot?.desc}
                      size="small"
                      sx={{
                        fontSize: 11,
                        backgroundColor: active ? `#A6818118` : "#f0f2f5",
                        color: active ? "#9A3B3B" : "#7b809a",
                        border: active ? `1px solid #A6818155` : "none",
                        fontWeight: 600,
                      }}
                    />
                  </Box>

                  {/* {active && (
                    <>
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: 12,
                          right: 12,
                          width: 24,
                          height: 24,
                          borderRadius: "50%",
                          backgroundColor: "#A68181",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#ffffff",
                          fontSize: 13,
                          fontWeight: 700,
                        }}
                      >
                        ✓
                      </Box>
                      <Box
                        sx={{
                          width: 20,
                          height: 20,
                          borderRadius: "50%",
                          border: `2px solid ${active ? "#A68181" : "#c0c0c0"}`,
                          backgroundColor: active ? "#FFF5F5" : "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                          transition: "border-color 0.2s",
                        }}
                      >
                        {active && (
                          <Box
                            sx={{
                              width: 10,
                              height: 10,
                              borderRadius: "50%",
                              backgroundColor: "#A68181",
                            }}
                          />
                        )}
                      </Box>
                    </>
                  )} */}
                </Box>
              </Grid>
            );
          })}
        </Grid>

        {touched?.slot && errors?.slot && (
          <FormHelperText error sx={{ mt: 1, color: "#F44335" }}>
            {errors?.slot}
          </FormHelperText>
        )}

        <Box mt={4} display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            size="large"
            disabled={!canStep0}
            onClick={() => handelCheckAmenityAvailable()}
            sx={{
              px: 5,
              borderRadius: 8,
              textTransform: "none",
              fontSize: 14,
              boxShadow: "none",
              backgroundColor: "#A68181",
              color: "#f3f1f1",
              "&:hover": { backgroundColor: "#9A3B3B", boxShadow: "none" },
              "&:disabled": { backgroundColor: "#dee2e6", color: "#6c757d" },
            }}
          >
            View Amenities <Iconify sx={{ ml: 1 }} icon="mdi:arrow-right" />
          </Button>
        </Box>
      </Paper>
    </Fade>
  );
};
